import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [showPwd, setShowPwd]   = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u?.roles?.includes('SUPER_ADMIN') ? '/plateforme' : '/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-shell" style={{ display: 'flex', minHeight: '100vh' }}>

      {/* ── Panneau gauche ─────────────────────── */}
      <section className="login-brand" style={{ position: 'relative', overflow: 'hidden', flex: '0 0 50%', minHeight: '100vh' }}>
        {/* Fond décoratif */}
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, #0f2744 60%, #1a3a5c)', zIndex: 0 }} />
        <div style={{ position: 'absolute', bottom: -120, right: -120, width: 400, height: 400, borderRadius: '50%', background: 'rgba(59,130,246,.15)', zIndex: 0 }} />
        <div style={{ position: 'absolute', top: -80, left: -80, width: 300, height: 300, borderRadius: '50%', background: 'rgba(59,130,246,.08)', zIndex: 0 }} />

        <div style={{ position: 'relative', zIndex: 1, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 48px', gap: 24, textAlign: 'center' }}>
          {/* Logo */}
          <div className="brand-lockup" style={{ justifyContent: "center" }}>
            <div className="brand-mark" style={{ width: 48, height: 48, fontSize: '1.4rem' }}>S</div>
            <div>
              <strong style={{ fontSize: '1.3rem', color: '#fff' }}>Schoolizy</strong>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,.5)', marginTop: 2 }}>Ioba</div>
            </div>
          </div>

          {/* Hero */}
          <div className="login-hero" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <h1 style={{ fontSize: 'clamp(1.6rem,3vw,2.4rem)', fontWeight: 700, color: '#fff', lineHeight: 1.15, marginBottom: 14, letterSpacing: '-.02em' }}>
              Votre espace<br />académique numérique
            </h1>
            <p style={{ color: '#93c5fd', lineHeight: 1.7, fontSize: 14, maxWidth: '40ch', textAlign: 'center' }}>
              Accédez à vos cours, notes, emplois du temps et bien plus encore depuis une seule plateforme.
            </p>

            {/* Logo école */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
              <img src="/logo-ioba.png" alt="Schoolizy Ioba" style={{ width: '100%', maxWidth: 280, display: 'block', margin: '0 auto 16px' }} />
            </div>
          </div>

          {/* Footer */}
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,.3)', textAlign: 'center' }}>
            © {new Date().getFullYear()} — Schoolizy · Groupe Scolaire Ioba
          </div>
        </div>
      </section>

      {/* ── Panneau droit ──────────────────────── */}
      <section className="login-form-wrap" style={{ background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 32px', flex: '0 0 50%', minHeight: '100vh' }}>
        <div style={{ width: 'min(420px, 100%)' }}>

          {/* En-tête */}
          <div style={{ marginBottom: 28 }}>
            <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--primary)', marginBottom: 6 }}>
              Espace établissement
            </div>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 4 }}>Connexion</h2>
            <p style={{ fontSize: 13, color: 'var(--muted)' }}>Entrez vos identifiants pour accéder à votre espace</p>
          </div>

          {error && <div className="form-error">{error}</div>}

          {/* Formulaire */}
          <form onSubmit={onSubmit} style={{ marginBottom: 24 }}>
            <div className="field">
              <label htmlFor="email">Identifiant (e-mail)</label>
              <input id="email" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="vous@ecole.bf"
                autoComplete="username"
                style={{ height: 44 }}
              />
              <small style={{ color: 'var(--muted)', fontSize: 11 }}>
                Administrateurs & enseignants : votre adresse e-mail
              </small>
            </div>

            <div className="field">
              <label htmlFor="password">Mot de passe</label>
              <div style={{ position: 'relative' }}>
                <input id="password" type={showPwd ? 'text' : 'password'} value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  style={{ height: 44, paddingRight: 40, width: '100%' }}
                />
                <button type="button" onClick={() => setShowPwd((v) => !v)}
                  style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 0, cursor: 'pointer', color: 'var(--muted)', fontSize: 16 }}>
                  {showPwd ? '🙈' : '👁'}
                </button>
              </div>
            </div>

            <button className="btn" type="submit" disabled={loading}
              style={{ width: '100%', height: 44, fontSize: 14, fontWeight: 600, marginTop: 8 }}>
              {loading ? 'Connexion…' : 'Se connecter'}
            </button>
          </form>

          {/* Footer */}
          <div style={{ marginTop: 24, textAlign: 'center', fontSize: 11, color: 'var(--muted)' }}>
            Schoolizy — Gestion scolaire UEMOA · © {new Date().getFullYear()}
          </div>
        </div>
      </section>
    </div>
  );
}
